import { trackCardLight } from '@lib/style/cardLight';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import classNames from 'classnames';
import { ReactNode } from 'react';
import css from './CapabilityCard.module.scss';

interface CapabilityCardProps {
  title: string;
  /** Status badges (NEW / BETA), shown over the preview's corner. */
  badges?: ReactNode;
  /** One line on what you get. */
  description: string;
  /** Decorative illustration of what the action produces. Hidden from assistive tech: the
   *  title and description carry the meaning. */
  preview: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  /** The podcast clipper's sub-brand: a purple-to-pink glow under the preview. */
  tone?: 'clipper';
}

/** One thing StarZero does: a preview of the result, and the whole card starts it. */
export const CapabilityCard = ({
  title,
  badges,
  description,
  preview,
  onClick,
  disabled,
  tone,
}: CapabilityCardProps) => (
  <button
    type="button"
    className={classNames(css.card, { [css.clipper]: tone === 'clipper' })}
    onClick={onClick}
    disabled={disabled}
  >
    <span className={css.preview} aria-hidden="true" onPointerMove={trackCardLight}>
      {preview}
    </span>
    {badges && <span className={css.badges}>{badges}</span>}
    <span className={css.body}>
      <span className={css.title}>
        {title}
        <ArrowForwardRoundedIcon className={css.arrow} />
      </span>
      <span className={css.description}>{description}</span>
    </span>
  </button>
);
